import * as SpecialOffersConstants from './constants';

export function shouldResetSpecialOffer(redeemStatus) {
  return ![
    SpecialOffersConstants.REDEEMING,
    SpecialOffersConstants.ErrorCodes.INVALID_CODE,
    SpecialOffersConstants.ErrorCodes.NO_TRIAL_ELIGIBILITY,
    SpecialOffersConstants.ErrorCodes.FAMILY_PLAN_AGE_INELIGIBLE,
    SpecialOffersConstants.ErrorCodes.UNEXPECTED_ERROR,
  ].includes(redeemStatus);
}

export function getSpecialOfferErrorData(specialOfferStatus) {
  const isFamilyPromoAgeError =
    specialOfferStatus === SpecialOffersConstants.ErrorCodes.FAMILY_PLAN_AGE_INELIGIBLE;
  const isAttemptingSidegrade =
    specialOfferStatus === SpecialOffersConstants.ErrorCodes.ALREADY_SUBSCRIBED;
  const shouldRedirectToRedeemComponent =
    specialOfferStatus === SpecialOffersConstants.ErrorCodes.INVALID_CODE ||
    specialOfferStatus === SpecialOffersConstants.ErrorCodes.UNEXPECTED_ERROR;
  const isIneligibleForOfferOrUpgrade =
    specialOfferStatus === SpecialOffersConstants.ErrorCodes.NO_TRIAL_ELIGIBILITY;

  return {
    isFamilyPromoAgeError,
    isIneligibleForOfferOrUpgrade,
    isAttemptingSidegrade,
    shouldRedirectToRedeemComponent,
  };
}
